"use client"

import styled from "@emotion/styled"
import { Box, Select } from "@mui/material"
import React from "react"
import ArrowDown2Icon from "../icons/ArrowDown2Icon"
import { Check2Icon, XIcon } from "../icons"
import {
  MultiSelectCheckbox,
  MultiSelectMenuItem,
  MultiSelectText,
  StyledClearIcon,
  StyledFieldIcon,
  multiSelectMenuProps,
  selectMenuProps,
} from "./shared"

const StyledSelect = styled(Select)`
  background-color: white;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  height: 48px;
  width: 100%;

  &:before,
  &:after {
    display: none !important;
  }

  &:hover {
    background-color: white;
  }

  &.Mui-focused {
    background-color: white;
    border-color: #0e2846;
  }

  .MuiSelect-select {
    padding: 0 !important;
    background-color: transparent !important;
    align-self: center;
    padding-inline-start: 12px !important;
    min-height: unset !important;
  }

  .MuiSelect-icon {
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
`

type SelectWithIconProps = {
  value: string | string[]
  onClear: () => void
  defaultIcon?: React.ComponentType<any>
  multiple?: boolean
  options?: string[]
  [key: string]: any
}

const SelectWithIcon = ({
  value,
  onClear,
  defaultIcon: DefaultIcon,
  multiple,
  options,
  ...props
}: SelectWithIconProps) => {
  const hasValue = multiple ? (value as string[]).length > 0 : !!value

  return (
    <Box sx={{ position: "relative" }}>
      <StyledSelect
        {...props}
        multiple={multiple}
        value={value}
        IconComponent={() => null}
        MenuProps={multiple ? multiSelectMenuProps : selectMenuProps}
        renderValue={
          multiple
            ? (selected: unknown) => {
                const arr = selected as string[]
                if (arr.length === 0) return props.placeholder || ""
                return <MultiSelectText>{arr.join(", ")}</MultiSelectText>
              }
            : props.renderValue
        }
      >
        {multiple && options
          ? options.map((opt: string) => {
              const isSelected = (value as string[]).includes(opt)
              return (
                <MultiSelectMenuItem key={opt} value={opt}>
                  <MultiSelectCheckbox $isSelected={isSelected}>
                    {isSelected && <Check2Icon />}
                  </MultiSelectCheckbox>
                  {opt}
                </MultiSelectMenuItem>
              )
            })
          : props.children}
      </StyledSelect>
      {hasValue ? (
        <StyledClearIcon
          onMouseDown={(e: any) => {
            e.stopPropagation()
            e.preventDefault()
            onClear()
          }}
        >
          <XIcon color="#0e2846" />
        </StyledClearIcon>
      ) : DefaultIcon ? (
        <StyledFieldIcon>
          <DefaultIcon color="#687079" />
        </StyledFieldIcon>
      ) : (
        <StyledFieldIcon>
          <ArrowDown2Icon />
        </StyledFieldIcon>
      )}
    </Box>
  )
}

export default SelectWithIcon
